import {
  PLOT_PARENT_CATEGORY,
  PLOT_CHILD_CATEGORY,
  PLOT_POINT_INPUT_FORMAT,
  PLANE_RECTANGULAR_CS_ZONE_JP,
} from "@/config/const";
import _ from "lodash";

const _privatePlotParentCategory = PLOT_PARENT_CATEGORY;
const _privatePlotChildCategory = PLOT_CHILD_CATEGORY;
const _privatePlotPointInputFormat = PLOT_POINT_INPUT_FORMAT;
const _plane_rectangular_cs_zone_jp = PLANE_RECTANGULAR_CS_ZONE_JP;

export default {
  data() {
    return {
      privatePlotParentCategory: _privatePlotParentCategory,
      privatePlotChildCategory: _privatePlotChildCategory,
      privatePlotPointInputFormat: _privatePlotPointInputFormat,
      plane_rectangular_cs_zone_jp: _plane_rectangular_cs_zone_jp,
    };
  },
  methods: {
    getPrivatePlotParentCategoryIds() {
      let ids = [];
      Object.keys(_privatePlotParentCategory.properties).forEach((key) => {
        ids.push(_privatePlotParentCategory.properties[key].id);
      });
      return ids.map((item) => String(item));
    },
    getPrivatePlotChildCategoryIds() {
      let ids = [];
      Object.keys(_privatePlotChildCategory.properties).forEach((key) => {
        ids.push(_privatePlotChildCategory.properties[key].id);
      });
      return ids.map((item) => String(item));
    },
    getParentCategoryProps(id) {
      return _privatePlotParentCategory.properties[id];
    },
    getPointInputFormatOptions() {
      return _.values(_privatePlotPointInputFormat.properties);
    },
    getRectangularCoordinateOptions() {
      return _.values(_plane_rectangular_cs_zone_jp.properties);
    },
    getRectangularCoordinate(zone) {
      return _plane_rectangular_cs_zone_jp.properties[zone].coordinate;
    },
  },
};
